import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uploadFile from '@/components/upload/uploadImg.vue';
import { getDetail as _getDetail, getLog as _getLog, rollback as _rollback, exceptionCard, getExceptionCard, getCustomerName } from './api/index';
export default {
  name: 'collectCardDetail',
  components: {
    uploadFile: uploadFile
  },
  props: {
    id: {
      type: [String, Number],
      default: ''
    }
  },
  data: function data() {
    return {
      info: {},
      logs: [],
      showDialog: false,
      exceptionCardForm: {
        card_management_id: '',
        exception_reason: '',
        exception_method: '',
        card_numbers: [{
          begin_code: '',
          end_code: ''
        }],
        file: [],
        note: ''
      },
      exception_method: [],
      exception_reason: [],
      numbers: '',
      linkUrl: {
        config: '/package/banner/upload/config',
        extensions: '/package/banner/upload/file-allow-extensions'
      },
      checked: false,
      checkList: [],
      dialogImageUrl: [],
      dialogImg: false,
      isIndeterminate: true,
      checkAll: false,
      exceptionCardInfo: {}
    };
  },
  created: function created() {
    this.exceptionCardForm.card_management_id = this.currentId;
    this.getDetail();
    this.getLog();
  },
  computed: {
    currentId: function currentId() {
      return this.id || this.$route && this.$route.query && this.$route.query.id || '';
    }
  },
  methods: {
    watchInfoOrder: function watchInfoOrder(data) {
      getCustomerName({
        customer_id: data.customer_id,
        role: '/orders/card-management/view'
      }).then(function (res) {
        data.customer_name = res.data.company_name;
      });
    },
    handleCheckAllChange: function handleCheckAllChange(val) {
      console.log(val, 7777);
      this.checkList = val ? this.exceptionCardForm.card_numbers.map(function (item, index) {
        return index;
      }) : [];
      this.isIndeterminate = false;
      if (val) {
        this.exceptionCardForm.card_numbers.forEach(function (item) {
          item.checked = 1;
        });
      } else {
        this.exceptionCardForm.card_numbers.forEach(function (item) {
          item.checked = 0;
        });
      }
      this.getTotal();
    },
    handleCheckedCitiesChange: function handleCheckedCitiesChange(value) {
      var _this = this;
      console.log(value, 888);
      var checkedCount = value.length;
      this.checkAll = checkedCount === this.exceptionCardForm.card_numbers.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.exceptionCardForm.card_numbers.length;
      this.exceptionCardForm.card_numbers.forEach(function (item) {
        item.checked = 0;
      });
      value.forEach(function (item) {
        _this.exceptionCardForm.card_numbers[item].checked = 1;
      });
      this.getTotal();
      console.log(this.exceptionCardForm.card_numbers);
    },
    handleDialogImg: function handleDialogImg(data) {
      this.dialogImg = true;
      this.dialogImageUrl = data.file;
      console.log(this.dialogImageUrl);
    },
    // handleCheckedCitiesChange(val) {
    // 	this.exceptionCardForm.card_numbers.forEach(item => {
    // 		item.checked = 0
    // 	})
    // 	val.forEach(item => {
    // 		this.exceptionCardForm.card_numbers[item].checked = 1
    // 	})
    // 	this.getTotal()
    // 	console.log(this.exceptionCardForm.card_numbers)
    // },
    delImgIndex: function delImgIndex(index) {
      this.exceptionCardForm.file.splice(index, 1);
    },
    emitUploadFile: function emitUploadFile(res) {
      this.exceptionCardForm.file.push("".concat(this.$ossurl).concat(res));
    },
    getDetail: function getDetail() {
      var _this2 = this;
      _getDetail({
        id: this.currentId
      }).then(function (res) {
        _this2.info = res.data;
      });
    },
    getLog: function getLog() {
      var _this3 = this;
      _getLog({
        card_management_id: this.currentId
      }).then(function (res) {
        _this3.logs = res.data.list;
      });
    },
    handleDialog: function handleDialog() {
      var _this4 = this;
      getExceptionCard({
        card_management_id: this.currentId
      }).then(function (res) {
        _this4.exception_method = Object.values(res.data.exception_method);
        _this4.exception_reason = Object.values(res.data.exception_reason);
        _this4.exceptionCardForm.card_numbers = res.data.card_numbers.map(function (item) {
          return {
            begin_code: item[0],
            end_code: item[1],
            checked: 1
          };
        });
        _this4.checkList = _this4.exceptionCardForm.card_numbers.map(function (item, index) {
          return index;
        });
        _this4.checkAll = true;
        _this4.isIndeterminate = false;
        _this4.exceptionCardInfo = res.data.info;
        _this4.getTotal();
        _this4.showDialog = true;
      });
    },
    closeDialog: function closeDialog() {},
    submit: function submit() {
      var _this5 = this;
      if (!this.checkList.length) {
        this.$message.error('请选择序列号段!');
        return;
      }
      exceptionCard(_objectSpread(_objectSpread({}, this.exceptionCardForm), {}, {
        card_numbers: this.exceptionCardForm.card_numbers.filter(function (item) {
          return item.checked;
        }).map(function (item) {
          return [item.begin_code, item.end_code];
        })
      })).then(function (res) {
        _this5.showDialog = false;
        _this5.getDetail();
        _this5.getLog();
      });
    },
    codeBlur: function codeBlur(val, item) {
      if (item.begin_code && item.end_code && Number(item.end_code) >= Number(item.begin_code)) {
        this.getTotal();
      }
    },
    getTotal: function getTotal() {
      var _this6 = this;
      this.numbers = 0;
      this.exceptionCardForm.card_numbers.forEach(function (item) {
        if (item.checked) {
          _this6.numbers += item.end_code - item.begin_code + 1;
        }
      });
      console.log(this.exceptionCardForm.card_numbers, 9999);
    },
    // 获取待售数据
    getExceptionCard: function getExceptionCard() {
      // getExceptionCard() {}
    },
    rollback: function rollback(data) {
      var _this7 = this;
      this.$confirm("\u5E8F\u5217\u53F7\u6BB5\uFF1A".concat(data.begin_code, "\uFF5E").concat(data.end_code, "\u7684\u552E\u5361\u72B6\u6001\u5C06\u4ECE\u3010\u4F5C\u5E9F\u3011\u53D8\u6210\u3010\u5F85\u552E\u3011\uFF0C\u60A8\u786E\u5B9A\u56DE\u9000\u5417\uFF1F"), '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        _rollback({
          log_id: data.id
        }).then(function (res) {
          _getLog({
            card_management_id: _this7.currentId
          }).then(function (res) {
            _this7.logs = res.data.list;
          });
        });
      }).catch(function (action) {});
    },
    handleClose: function handleClose() {
      this.$emit('close');
    }
  }
};